













import { Global } from '@/store/globalz';
import globalx from '@/store/modules/globalx';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import OverlayCanvasComponent from '../canvas/OverlayCanvasComponent.vue';

@Component({
	components: {
		OverlayCanvasComponent,
	},
})
export default class OverlayComponent extends Vue {
	public bool: boolean = false;
	public showAdBlocker: boolean = false;
	public interval: any;
	public secLeft = 45;

	public get toShowNextRevealButton() {
		return globalx.toShowNextRevealButton;
	}
	public get showingGachaAnimation() {
		return globalx.showingGachaAnimation;
	}
	public videoAdReady = false;
	public videoShowing = false;

	public onRevealNext() {
		if (this.toShowNextRevealButton && Global.skinGachaControl) {
			Global.skinGachaControl.revealNext();
		}
	}
	public onSkipGacha() {
		if (Global.skinGachaControl) {
			Global.skinGachaControl.skipGacha();
		}
	}
	// ### End Reincarnation
}
